"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const base_react_components_1 = require("@navinc/base-react-components");
const need_more_info_warning_1 = __importDefault(require("../../../components/need-more-info-warning"));
const business_address_1 = __importDefault(require("../../../components/business-address"));
const bureaus_1 = require("../../../utils/bureaus");
const InputWrapper = styled_components_1.default.div.withConfig({ displayName: "reports-InputWrapper", componentId: "reports-1dvpgu9" }) `
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
`;
exports.default = ({ bureauSlug, businessAddress, 'data-testid': dataTestId, }) => {
    var _a, _b;
    return (react_1.default.createElement(need_more_info_warning_1.default, { title: "No score due to a bankruptcy for:", dataTestId: dataTestId },
        react_1.default.createElement(business_address_1.default, Object.assign({}, businessAddress)),
        react_1.default.createElement(base_react_components_1.Copy, null,
            "A recent bankruptcy is showing on your ", (_b = (_a = (0, bureaus_1.getBureau)(bureauSlug)) === null || _a === void 0 ? void 0 : _a.displayName) !== null && _b !== void 0 ? _b : 'bureau',
            " report, so Experian can't generate a score for you right now."),
        react_1.default.createElement(base_react_components_1.Copy, null, "If this is an error, you can dispute the inaccurate information with the bureaus."),
        react_1.default.createElement(InputWrapper, null,
            react_1.default.createElement(base_react_components_1.Link, { "data-testid": `premium-${bureauSlug}-overview-not-my-business-link`, to: `/partner/business-match/${bureauSlug}` },
                react_1.default.createElement(base_react_components_1.Button, { variation: "outline" }, "This is not my business")))));
};
//# sourceMappingURL=recent-bankruptcy-message.js.map